import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function speak(text, lang = "ja-JP") {
  if (typeof window === "undefined" || !("speechSynthesis" in window)) return;
  try {
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = lang;
    utter.rate = 0.9;
    utter.pitch = 1.05;
    // Try to pick a Japanese voice
    const voices = window.speechSynthesis.getVoices();
    const jp = voices.find((v) => v.lang && v.lang.toLowerCase().startsWith("ja"));
    if (jp) utter.voice = jp;
    window.speechSynthesis.speak(utter);
  } catch {
    // TTS is a best-effort enhancement; silently skip if unavailable.
  }
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
